import { SET_PROJECT, SET_PROJECTS } from "../../constants/projectConstants";

export const setProject = (project) => {
  return {
    type: SET_PROJECT,
    project,
  };
};

export const setProjects = (projects, filtered = false) => {
  return {
    type: SET_PROJECTS,
    projects,
    filtered,
  };
};
